import { emptyFeatures } from './feature-seed';

/**
 * The resolved FRBAC answer on the wire. The overrides ride along rather than being folded into
 * allow and deny, because a shadow role is the final authority in hasAccess — flattening them
 * would make the navigation answer a different question from the endpoint behind it.
 */
export type EffectiveFeatures = {
  allow: string[];
  deny: string[];
  overrides: {
    allow: string[];
    deny: string[];
  };
};

/**
 * The fetch layer behind the feature provider.
 *
 * It carries none of the shell's 401 handling on purpose. This endpoint is advisory — what
 * denies is the route policy on the server, and the session poll is what signs the tabs out — so
 * a refused answer means "nothing granted yet", not "end the session". Broadcasting a logout from
 * here would sign a guest out of the login page they are standing on.
 */
export function createUserFeaturesApi() {
  async function getFeatures(): Promise<EffectiveFeatures> {
    const response = await fetch('/api/user/features', { credentials: 'same-origin' });
    let features = emptyFeatures();
    if (response.ok) {
      features = (await response.json()) as EffectiveFeatures;
    }
    return features;
  }

  return { getFeatures: getFeatures };
}
